import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router , NavigationEnd } from '@angular/router';
import browserDetect from 'browser-detect';
import { AppConfigService } from './core/services/app-config.service';
import { AppMessagesService } from './core/services/app-messages.service';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { allowedNodeEnvironmentFlags } from 'process';
import { environment } from '../environments/environment';
import { AppServiceService } from './core/services/app-service.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  browserNameAndVersion: any;
  browserName: string;
  SupportedBrowser: boolean = true;
  deviceInfo: DeviceInfo;
  browseres: any;
  flagCenterComponenet:boolean = false;
  moeLogin:boolean;
  hideMenuSide:boolean = false;
  hideQuestions:boolean = false;
  hideFooter:boolean = false;
  routeUrl:string;
  @ViewChild('myFormPost') myFormPost: ElementRef;
  varAction:any = window['_serverUrl'];
  varTarget:any = window['_target'];
  showLogoutMessage:boolean = false;
  timeOutLogout:number;
  timeOutToShowMessage:number;
  phoneSupportMoe:string;
  protocol:string;
  isFieldFilled: boolean = false;
  pageValue:string = "";
  pagesToNavigates : string[]=[
  "GeneralError"
  ]
  constructor(private _router: Router,private _appService:AppServiceService,
     private _appConfigService: AppConfigService, private _appMessageService: AppMessagesService
    , private deviceDetectorService: DeviceDetectorService) { }
    time:number;
    interval;
    startTimer() {  
      clearInterval(this.interval)
      this.time=0;
      if(this.isFieldFilled ){ 

      this.interval = setInterval(() => {
        this.time++;  
      if(this.time ==  this.timeOutLogout - this.timeOutToShowMessage)  {
        this.showLogoutMessage = true;
      } 
      if(this.time == this.timeOutLogout ){      
        this._appService.doReset();          
       }   
       
      },60000) 
    }
  }

  
  
  
    @HostListener('mousemove', ['$event'])
    handleMousemove(event) {
      if(!this.showLogoutMessage) 
      this.startTimer();
  }
  
    @HostListener('scroll', ['$event'])
    onScroll(event) {
      if(!this.showLogoutMessage) 
      this.startTimer();
    }
  
    
    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) { 
      if(!this.showLogoutMessage)
      this.startTimer();
    }

  
  getIfBrowserSupport(browseres, deviceInfo) {
    var flag = true;
    var index = browseres.findIndex(obj => obj.browser === deviceInfo.browser || deviceInfo.browser.toUpperCase().includes(obj.browser.toUpperCase()));
    if (index > -1) {
      if (browseres[index].version > parseInt(deviceInfo.browser_version) || browseres[index].version == 0) {
        flag = false;
      }
      else {
        flag = true;
      }
    }
    return flag;
  }

  ngOnInit(): void {
     this._appService.targetReferrer = document.referrer;
      this._appService.fieldFilled$.subscribe(isFilled => {
        this.isFieldFilled = isFilled;
      });
      this.startTimer();

    this.protocol = window['_serverUrl'];
       this._appConfigService.getPhoneSupportMoe().subscribe(    
        (data) => { 
          this.phoneSupportMoe = data;
        },
        (error) => {
          //TODO
        })
    this._appConfigService.getLogoutTime().subscribe(
      (data) => {
        this.timeOutLogout= data.timeOutLogout;
        this.timeOutToShowMessage= data.timeOutToShowMessage
      },
    )
    this._appService.redirect$.subscribe(() => {    
        this.myFormPost.nativeElement.submit().subscribe(       
          (data)=>{alert("redirectTarget succeeded");},
          (error)=>{alert("redirectTarget failed");}
        ); 
    });

      this._appService.logoutPopup$.subscribe(      
        (data)=>{ 
          switch (this._appService.componentName) {      
            case this._appService.listComponentName['loginViaOtpMoe']: {
              document.getElementById("otpMoe").focus();
              break;
            }
            case this._appService.listComponentName['loginViaOtp']: {
              document.getElementById("otp").focus();
              break;
            }
            case this._appService.listComponentName['loginViaSms']: {
              document.getElementById("idCard").focus();
              break;
            }
            case this._appService.listComponentName['loginViaPassword']: {
              document.getElementById("userName").focus();
              break;
            }
            case this._appService.listComponentName['loginViaPasswordMoe'] : {
              document.getElementById("userName").focus();
              break;
            }
            default: {
              //statements; -TODO
              break;
            }
          }
        },
        (error)=>{
        }
      );

    if(environment.inMemoryWebApi){
      this._appService.loginType = "SBSLogin"
     // this._appService.isMoeLogin = true ;

    }
    if(this._appService.componentName == 'login-combined-edu-gov'){
    this.flagCenterComponenet = true;
  }
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    this._appConfigService.getSupportBrowsers().subscribe(
      (data) => {
        this.browseres = data;
      },
    )
 
    this.SupportedBrowser = this.getIfBrowserSupport(this.browseres, this.deviceInfo);
    if (!this.SupportedBrowser) {
      switch (window['_loginType']) {
        case window['_loginTypeUsernamePassword']: {
              window.location.href = window['_loginMethodUsernamePasswordURLOld'];
          break;
        }
        case window['_loginTypeUsernameSMSOTP']: {
             window.location.href = window['_loginMethodUsernameSMSOTPURLOld'];
          break;
        }
        // case window['_loginTypeOTPOnly']: {
        //   window.location.href = window['_loginMethodloginTypeOTPOnlyURLOld'];//not exists
        //   break;
        // }
        default: {
          //window.location.href = window['_loginMethodUsernamePasswordURLOld'];
          this._router.navigate(['browserSupport'], { skipLocationChange: true });
          break;
        }
      }
    }
    else {
    const urlSearchParams = new URLSearchParams(window.location.search);
     this.pageValue = urlSearchParams.get('page');
      if(this.pageValue!= null && this.pagesToNavigates.includes(this.pageValue)){   
        this.hideMenuSide = true;
        this.routeUrl = this.pageValue;
        this._router.navigate([this.routeUrl], { skipLocationChange: true });
      } 
     else {
      this._appService.isMoeLogin = false;
      switch (window['_loginType']) {
        case window['_loginTypeIDPSelect']: {
          this._appService.loginType = "CombinedGovEduLogin"
          this._router.navigate(['login'], { skipLocationChange: true });
          break;
        }
        case window['_loginTypeUsernameSMSOTP']: {
          this._appService.loginType = "SBSLogin"
          this._router.navigate(['loginWithIdAndMobile'], { skipLocationChange: true });
          break;
        }
        case window['_loginTypeUsernamePassword']: {
          this._appService.loginType = "SBSLogin"
          this._router.navigate(['loginWithIdAndMobile'], { skipLocationChange: true });
          break;
        }
        case window['_loginTypeOTPOnly']: {
          this._appService.loginType = "OtpOnlyLogin"
          this._router.navigate(['loginOtpOnly'], { skipLocationChange: true });
          break;
        }
        case window['_loginTypeMOEUserPassSMS']: {
          this._appService.isMoeLogin = true;
          this._router.navigate(['loginPasswordMoe'], { skipLocationChange: true });
          break;
        }
        case window['_loginTypeUsernamePasswordSMSOTP']: {
          this._router.navigate(['loginViaPassword'], { skipLocationChange: true });
          break;
        }
        case window['_errorPageType']: {
          this._router.navigate(['GeneralError'], { skipLocationChange: true });
          break;
        }
        default: {
          this._router.navigate(['GeneralError'], { skipLocationChange: true });
          break;
        }
      }
    }
  }


   this._appService.hideFooter = this.hideFooter=this._appService.isMoeLogin;
   this.moeLogin = this._appService.isMoeLogin;
   this._appMessageService.setErrorMessages();
   }

   onActivate(componentRef) {
    setTimeout(() => {
      this.flagCenterComponenet = this._appService.componentName =='login-combined-edu-gov-component';
      this._appService.hideMenuSide = this.hideMenuSide= this._appService.isMoeLogin || this.flagCenterComponenet;
      this._appService.hideQuestions =  this.hideQuestions = this._appService.isMoeLogin || this.flagCenterComponenet;

    // console.log( this.componentName)
    }, 0);
  }

  convertCamelToKabab(str: string) {
    return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(x => x.toLowerCase())
      .join('-');
  }
  closePopup() {
    this.startTimer();
    this.showLogoutMessage= false;
    this._appService.focusAfterLogoutPopup();
  }

  logout(){
    this._appService.doReset(); 
    }

}
